module.exports = __webpack_public_path__ + "static/media/hotel.1d1c641d.svg";